export default "__VITE_ASSET__BP0lP$X___"